module.exports = __webpack_public_path__ + "static/img/2.644e293.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/eng/2.png
// module id = hRun
// module chunks = 0